import { EventMapper, META_EVENT_MAP } from '../eventMapper';
import { AnalyticsAdapter, AnalyticsConfig, AnalyticsEventParams, AnalyticsUser, XegueiEventName } from '../types';

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

/**
 * Adapter Meta Pixel — carregamento dinâmico (lazy) do script oficial.
 * Garante init único por pixelId e suporte SPA (cada track usa eventID
 * próprio para deduplicação com a CAPI server-side).
 */
export class MetaPixelAdapter implements AnalyticsAdapter {
  public readonly name = 'meta-pixel';
  private initialized = false;
  private pixelId?: string;

  isReady(): boolean {
    return this.initialized && typeof window !== 'undefined' && !!window.fbq;
  }

  async initialize(config: AnalyticsConfig): Promise<void> {
    if (this.initialized) return;
    if (!config.metaPixelId) return;
    if (typeof window === 'undefined') return;

    this.pixelId = config.metaPixelId;

    // Snippet oficial fbq (https://developers.facebook.com/docs/meta-pixel)
    /* eslint-disable */
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = (f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode!.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', this.pixelId);
    this.initialized = true;
  }

  track(event: XegueiEventName, params: AnalyticsEventParams, _user?: AnalyticsUser): void {
    if (!this.isReady()) return;
    const metaName = META_EVENT_MAP[event] || event;
    const metaParams = EventMapper.toMetaParams(params);
    const opts: any = {};
    if (params.eventId) opts.eventID = params.eventId;

    // Standard vs Custom. RemoveFromCart e AbandonCheckout não são standard.
    const isStandard = event !== 'RemoveFromCart' && event !== 'AbandonCheckout';
    try {
      if (isStandard) {
        window.fbq('track', metaName, metaParams, opts);
      } else {
        window.fbq('trackCustom', metaName, metaParams, opts);
      }
    } catch (err) {
      console.warn('[MetaPixel] track falhou', err);
    }
  }

  page(params?: AnalyticsEventParams): void {
    this.track('PageView', params || {});
  }
}
